<template>
  <ChartTitleWrapper :title="title">
    <VueApexCharts type="line" :height="350" :options="chartOptions" :series="series" />
  </ChartTitleWrapper>
</template>

<script setup>
import { computed } from "vue";
import VueApexCharts from "vue3-apexcharts";

import { getChartOptions, getTableSeriesBasedOnDays } from "@/app/reports/utils/chart";

import ChartTitleWrapper from "@/app/reports/components/charts/ChartTitleWrapper.vue";

const props = defineProps({
  title: String,
  data: Object,
  labels: Array,
});

const chartOptions = getChartOptions({
  xAxis: {
    title: "Días",
    categories: props.labels,
  },
  yAxis: {
    title: "Número de llamadas",
  },
  chartColors: ["#D9F7BE", "#FFE58F", "#FFA39E", "#91D5FF"],
  legend: {
    show: true,
  },
});

const series = computed(() => [
  {
    name: "Llamadas recibidas",
    data: getTableSeriesBasedOnDays({
      dataObject: props.data?.find((item) => item.description === "Llamadas recibidas"),
    }),
  },
  {
    name: "Llamadas atendidas",
    data: getTableSeriesBasedOnDays({
      dataObject: props.data?.find((item) => item.description === "Llamadas atendidas"),
    }),
  },
  {
    name: "Llamadas atendidas del NS",
    data: getTableSeriesBasedOnDays({
      dataObject: props.data?.find((item) => item.description === "Llamadas atendidas NS"),
    }),
  },
  {
    name: "Llamadas abandonadas",
    data: getTableSeriesBasedOnDays({
      dataObject: props.data?.find((item) => item.description === "Llamadas abandonadas"),
    }),
  },
]);
</script>

<style lang="sass" scoped>
h3
  font-size: 16px
  font-weight: 600
  margin: 35px 0 12px 0
  text-align: center
</style>
